import {
  Arrange,
  Button,
  Container,
  Icon,
  IconButton,
  Spacer,
  SvgClose,
  SvgInfo,
  Text,
} from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { openModal } from 'actions/modals';
import {
  APPROACHING_CONTENT_LIMIT_UPGRADE_CLIKED,
  STORAGE_INCENTIVE_INVITE_TEAMMATES_CTA_CLICKED,
} from 'constants/events';
import { TEAM_INVITE_MODAL } from 'constants/modalTypes';
import { WORKSPACE_PLAN_BUSINESS } from 'constants/workspacePlans';
import { requestUpgrade } from 'creators/upgrades';

import { useGetSelectedWorkspace } from 'hooks/workspace';

import * as analytics from '../../../utilities/analytics';
import { APPROACHING_CONTENT_LIMIT_BANNER } from '../constants';
import { MemberVideoLimits } from '../types';

interface ApproachingLimitBannerProps {
  // This is just the shape of the object returned in the useGetMemberVideoLimits hook
  // but that hook isn't TS so we're rolling with this for now
  memberVideoLimit: MemberVideoLimits;
  handleClose: () => void;
}

function ApproachingLimitBanner({
  memberVideoLimit,
  handleClose,
}: ApproachingLimitBannerProps): JSX.Element {
  const dispatch = useDispatch();
  const workspace = useGetSelectedWorkspace();

  function handleUpgrade() {
    dispatch(
      requestUpgrade({
        analyticsEvent: APPROACHING_CONTENT_LIMIT_UPGRADE_CLIKED,
        selectedWorkspace: workspace,
        minPlanForFeature: WORKSPACE_PLAN_BUSINESS,
      })
    );
  }

  function handleInviteTeammates() {
    dispatch(openModal(TEAM_INVITE_MODAL));

    analytics.track(STORAGE_INCENTIVE_INVITE_TEAMMATES_CTA_CLICKED, {
      source: APPROACHING_CONTENT_LIMIT_BANNER,
    });
  }

  return (
    <>
      <Container
        paddingX="medium"
        paddingY="small"
        backgroundColor="yellowLight"
        radius="medium"
      >
        <Arrange justifyContent="space-between" gap="small">
          <Arrange justifyContent="start" gap="small">
            <Icon icon={<SvgInfo />} size="large" />
            <Text>
              <b>
                You&apos;ve recorded {memberVideoLimit.totalVideos}/
                {memberVideoLimit.limit} videos.
              </b>{' '}
              Invite teammates or upgrade your plan to earn free videos.
            </Text>
          </Arrange>
          <Arrange justifyContent="end" gap="small">
            <Button onClick={handleInviteTeammates}>Invite Teammates</Button>
            <Button onClick={handleUpgrade}>Upgrade Plan</Button>
            <IconButton
              altText="close"
              icon={<SvgClose />}
              size="medium"
              onClick={handleClose}
            />
          </Arrange>
        </Arrange>
      </Container>
      <Spacer bottom="medium" />
    </>
  );
}

export default ApproachingLimitBanner;
